export default "__VITE_ASSET__C9Lvg18m__"